import { createFileRoute, redirect } from '@tanstack/react-router'

import SignInPage from '@/components/pages/auth/sign-in/containers/SignInPage'

export const Route = createFileRoute('/auth/sign-in')({
  beforeLoad: ({ context: { isAuthenticated } }) => {
    if (isAuthenticated) {
      throw redirect({ to: '/', replace: true })
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    error: search.error as string | undefined | null
  }),
  loaderDeps: ({ search }) => ({ error: search.error }),
  component: SignInPage
})
